module.exports = __webpack_public_path__ + "static/media/loyalty-icon@3x.f5bef016.png";